import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import {SmActionButtonModule} from '../sm-action-button/sm-action-button.module';
import {SmNavMenuItemModule} from '../sm-nav-menu-item/sm-nav-menu-item.module';
import {SmNavBarComponent} from './sm-nav-bar.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    SmActionButtonModule,
    SmNavMenuItemModule,
  ],
  declarations: [SmNavBarComponent],
  exports: [SmNavBarComponent],
})
export class SmNavBarModule {}
